var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.object.link)?_c('router-link',{attrs:{"to":_vm.object.link}},[_vm._v(_vm._s(_vm.object.name))]):[_vm._v(_vm._s(_vm.object.name))]],2)}
var staticRenderFns = []

export { render, staticRenderFns }